import React, { useEffect, useContext } from "react";
import { Link, graphql, useStaticQuery } from "gatsby";
import tw from "twin.macro";

import Hero from "../hero";
import { Container as ContainerBase } from "../section";
//import TrialCard from "./trial-card";
import TrialsContext from "./context";

const TrialsGrid = tw(ContainerBase)`container mx-auto space-y-4`;
const Heading = tw.h2`font-bold text-lg uppercase`;

const DocTable = tw.table`text-sm w-full block md:table table-fixed overflow-x-scroll`;
const DocTableHeader = tw.thead`hidden md:table-header-group sticky top-0`;
const DocTableHeading = tw.th`text-left p-2 bg-gray-50`;
const DocTableHeadingTitle = tw(DocTableHeading)`w-8/12`;
const DocTableBody = tw.tbody`divide-y divide-gray-100`;
const DocTableRow = tw.tr`py-2 md:p-2 block md:table-row`;
const DocTableItem = tw.td`md:p-2 block md:table-cell`;
const DocTableItemLabel = tw.span`inline text-gray-500 md:hidden`;
const DocLink = tw(
  Link
)`leading-tight text-blue-900 hover:text-blue-700 focus:text-blue-700 font-bold`;
const DocTitle = tw.div`leading-tight`;
const DocMeta = tw.span`block text-xs text-gray-500`;

const TrialsPage = () => {
  const data = useStaticQuery(graphql`
    query {
      file(relativePath: { eq: "resources-banner.jpeg" }) {
        childImageSharp {
          fluid(maxWidth: 1440) {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  `);

  const trialsContext = useContext(TrialsContext);
  const { loading, error, trials, otherTrials, getTrials } = trialsContext;


  const statusToColor = (status) => {
    const statuses = [ "RECRUITING", "ACTIVE_NOT_RECRUITING", "NOT_YET_RECRUITING" ]
    //status == statuses[0] ? "text-green-700" : status == statuses[1] ? "text-blue-700" : status == statuses[2] ? "text-red-700" : "";
    const formatted = status.replaceAll("_", " ").toLowerCase();
    switch (status){
      case statuses[0]: 
        return <span tw="text-green-600 font-bold capitalize">{formatted}</span>
      case statuses[1]:
        return <span tw="text-gray-700 font-bold capitalize">{formatted}</span>
      case statuses[2]:
        return <span tw="text-blue-500 font-bold capitalize">{formatted}</span>
      default:
        return <span tw="capitalize">{formatted}</span>
    }
  }


  useEffect(() => {
    getTrials();
    //eslint-disable-next-line
  }, []);

  return (
    <>
      <Hero imgQuery={data.file.childImageSharp.fluid}>Trials</Hero>
      <TrialsGrid>
        {loading ? (
          <p>Loading...</p>
        ) : error ? (
          error
        ) : (
          <>
            <Heading>Active Trials</Heading>
            <DocTable>
              <DocTableHeader>
                <tr>
                  <DocTableHeadingTitle>Title</DocTableHeadingTitle>
                  <DocTableHeading>Status</DocTableHeading>
                  <DocTableHeading>DCP ID</DocTableHeading>
                </tr>
              </DocTableHeader>
              <DocTableBody>
                {trials.map(t => (
                  <DocTableRow key={t.dcpid}>
                    <DocTableItem>
                      <DocTableItemLabel>Title:</DocTableItemLabel>
                      {t.nctid ? (
                        <DocLink to={`/trials/view?nctid=${t.nctid}`}>
                          {t.title}
                        </DocLink>
                      ) : (
                        <DocTitle>{t.title}</DocTitle>
                      )}
                      <DocMeta>{t.sponsor}</DocMeta>
                    </DocTableItem>
                    <DocTableItem>{statusToColor(t.status)}</DocTableItem>
                    <DocTableItem>{t.dcpid}</DocTableItem>
                  </DocTableRow>
                ))}
              </DocTableBody>
            </DocTable>

            <Heading>DCP-Approved Trials</Heading>
            <DocTable>
              <DocTableHeader>
                <tr>
                  <DocTableHeadingTitle>Title</DocTableHeadingTitle>
                  <DocTableHeading>Status</DocTableHeading>
                  <DocTableHeading>DCP ID</DocTableHeading>
                </tr>
              </DocTableHeader>
              <DocTableBody>
                {otherTrials.map(t => (
                  <DocTableRow key={t.dcpid}>
                    <DocTableItem>
                      <DocTableItemLabel>Title:</DocTableItemLabel>
                      {t.nctid ? (
                        <DocLink to={`/trials/view?nctid=${t.nctid}`}>
                          {t.title}
                        </DocLink>
                      ) : (
                        <DocTitle>{t.title}</DocTitle>
                      )}
                      <DocMeta>{t.sponsor}</DocMeta>
                    </DocTableItem>
                    <DocTableItem>{t.status.replace('_', " ")}</DocTableItem>
                    <DocTableItem>{t.dcpid}</DocTableItem>
                  </DocTableRow>
                ))}
              </DocTableBody>
            </DocTable>
          </>
        )}
      </TrialsGrid>
    </>
  );
};

export default TrialsPage;
